import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipologieCostruttiveFormComponent } from './dialogs/form/form.component';
import { TipologieCostruttiveComponent } from './tipologie-costruttive.component';


const routes: Routes = [
  {
    path: '', component: TipologieCostruttiveComponent
  },
  {
    path: 'inserisci', component: TipologieCostruttiveFormComponent,
    data: { title: 'Inserimento TipologieCostruttive' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipologieCostruttiveRoutingModule { }
